import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CtaBand() {
  return (
    <section className="bg-onyx border-t border-gold/15 py-10 md:py-20 text-center">
      <div className="mx-auto max-w-2xl px-6">
        <h2 className="font-display text-3xl md:text-4xl tracking-wide text-ivory">Ready to Glow?</h2>
        <p className="mt-3 text-muted-ivory">Your beauty, our expertise.</p>
        <Link
          to="/book"
          className="btn-gold mt-8 inline-flex items-center gap-2.5 px-9 py-4 text-[0.72rem] tracking-[0.24em] uppercase"
        >
          Book Your Appointment <ArrowRight size={16} />
        </Link>
      </div>
    </section>
  );
}
